import { API } from 'aws-amplify'
import AmplifyStore from '../store/store'

/**
 * Utils service calling the api (useful if we need to add custom headers)
 */
class ApiService {
  async apiGet (path, queryParameters) {
    let params = {
      headers: {
        user: this.getJsonUserDetails()
      },
      queryStringParameters: queryParameters
    }
    return API.get('api', path, params)
  }

  async apiPut (path, bodyParameters) {
    let params = {
      headers: {
        user: this.getJsonUserDetails()
      },
      body: bodyParameters
    }
    return API.put('api', path, params)
  }

  async apiPost (path, bodyParameters) {
    let params = {
      headers: {
        user: this.getJsonUserDetails()
      },
      body: bodyParameters
    }
    return API.post('api', path, params)
  }

  async apiDelete (path) {
    let params = {
      headers: {
        user: this.getJsonUserDetails()
      }
    }
    return API.del('api', path, params)
  }

  getJsonUserDetails () {
    return JSON.stringify({
      id: AmplifyStore.state.user.id,
      name: AmplifyStore.state.user.name,
      email: AmplifyStore.state.user.email
    })
  }
}

/**
 * Cloud endpoint: contains "functional" methods to call in components
 */
const apiService = new ApiService()
export default class CloudEndpointService {
  errorHandler (err) {
    console.log(err)
    if (err.response) {
      console.log(err.response)
      let responseData = err.response.data
      if (responseData && responseData.status) {
        return {
          'status': responseData.status,
          'message': responseData.message
        }
      }
    }
    return null
  }

  async shrinkUrl (url) {
    let that = this
    return apiService.apiPost('/urls', [{
      'target': url
    }]).then(response => {
      return response[0].name
    }).catch(err => {
      return that.errorHandler(err)
    })
  }

  async shrinkSpecificUrl (url, name) {
    let that = this
    return apiService.apiPost('/urls', [{
      'target': url,
      'name': name
    }]).then(response => {
      return response[0].name
    }).catch(err => {
      return that.errorHandler(err)
    })
  }

  async getUrls () {
    let that = this
    return apiService.apiGet('/urls').then(response => {
      return response
    }).catch(err => {
      return that.errorHandler(err)
    })
  }

  async deleteUrl (name) {
    return apiService.apiDelete('/url/' + name).then(response => {
      return true
    }).catch(err => {
      console.error(err)
      return false
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/cloud-endpoint.js